module.exports = __webpack_public_path__ + "36a398cb91c517896a287cf4444aa675.svg";